import { selectAll } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class StatsCarousel {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.teamCarouselContainer = selectAll("[data-stats-carousel]");
  }

  render() {
    this.statsCarousel();
  }

  statsCarousel = () => {
    for (var i = 0; i < this.teamCarouselContainer.length; i++) {
      new Swiper(this.teamCarouselContainer[i], {
        slidesPerView: 1,
        spaceBetween: 113,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };


  };
}